import { Divider, SystemIcon } from "@justworkshr/milo-components";
import styles from "./EmployeeTableUpsell.module.css";
import DependentBox from "./DependentBox";
import AddUpsellDependent from "pages/CensusAndCurrentInformation/components/CurrentEmployees/AddUpsellDependent";
import { useState } from "react";
import { SingleCurrentEmployeesType, SingleDependentType } from "types";
import { convertToTitleCase, ConvertToValidDate } from "utils/helper";

export interface EmployeeTableUpsellForm {
  data: SingleCurrentEmployeesType;
}

const EmployeeTableUpsell = ({
  ...props
}: EmployeeTableUpsellForm): JSX.Element => {
  const { data } = props;
  const [addMoreDependents, setAddMoreDependents] = useState(false);
  const [dependentList, setDependentList] = useState(
    data.dependentCensuses || []
  );

  const hasDependents = (dependentList?.length ?? 0) > 0;

  const getInitials = (firstName: string, lastName: string): string => {
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  };
  const getBoxTitle = (dependentsLength: number): string => {
    const dependentsText = dependentsLength > 1 ? "Dependents" : "Dependent";
    return `${dependentsLength} ${dependentsText}`;
  };

  const closeParentDialog = () => {
    setAddMoreDependents(false);
  };

  const updateDependentList = (
    newDependent: SingleDependentType,
    method: "Delete" | "Add" | "Edit"
  ) => {
    switch (method) {
      case "Add":
        setDependentList([...dependentList, newDependent]);
        break;
      case "Delete":
        const newDependentList = dependentList.filter(
          (dependent) => dependent.uuid !== newDependent.uuid
        );
        setDependentList(newDependentList);
        break;
      case "Edit":
        const editedDependentIndex = dependentList.findIndex(
          (dependent) => dependent.uuid === newDependent.uuid
        );
        const editedDependentList = [...dependentList];
        editedDependentList[editedDependentIndex] = newDependent;
        setDependentList(editedDependentList);
        break;
    }
  };

  return (
    <div>
      <div className={styles.tableCell}>
        <div className={styles.test}>
          <div className={styles.empName}>
            <span className={styles.initialsIcon}>
              {getInitials(data.firstName, data.lastName)}
            </span>
            <span
              className={styles.initials}
            >{`${data.firstName} ${data.lastName}`}</span>
          </div>
          <div className={styles.empDetails}>
            {ConvertToValidDate(data.dateOfBirth)}
            <SystemIcon
              iconName="bullet"
              color="disabled"
              title="bullet"
              size="extra-small"
            />
            {convertToTitleCase(data.gender)}
            <SystemIcon
              iconName="bullet"
              color="disabled"
              title="bullet"
              size="extra-small"
            />
            {data.homeZip}
          </div>
        </div>
        <div
          className={styles.addDependentText}
          onClick={() => setAddMoreDependents(true)}
        >
          Add dependents
        </div>
      </div>
      {addMoreDependents && (
        <AddUpsellDependent
          employeeId={data.uuid}
          employeeName={`${data.firstName} ${data.lastName}`}
          closeParentDialog={closeParentDialog}
          updateDependentList={updateDependentList}
        />
      )}
      {hasDependents && (
        <>
          <Divider spacing="xs" />
          <DependentBox
            title={getBoxTitle(dependentList?.length)}
            dependentDescription={dependentList}
            updateDependentList={updateDependentList}
          />
        </>
      )}
      <Divider spacing="xs" />
    </div>
  );
};

export default EmployeeTableUpsell;
